/**
 * Custom forms Events
 */
export const customFormsAuditEvents = {
    created: "Custom Form Created",
    duplicate: "Custom Form Duplicated",

    /**
     * Payload: {
     *      "question type": string,
     *      "question position": "root" | "branch",
     * }
     */
    questionAdded: "Custom Form Question Selected",

    /**
     * Payload: {
     *      action:  'moved up' | 'moved down' | 'deleted' | 'dragged' | 'required toggled' | 'custom field linked' | 'custom field unlinked',
     *      required: 'true' | 'false' // only for 'required toggled' action
     *      "question type": string,
     * }
     */
    questionUpdated: "Custom Form Question Updated",

    /**
     * Whenever user clicks on 'Add Branch' button
     */
    branchAdded: "Custom Form Branch Added",

    /**
     * Payload: {
     *      action: 'option added' | 'option renamed' | 'option deleted' | 'option order changed',
     * }
     */
    questionOptionUpdated: "Custom Form Question Option Used",

    record: {
        opened: "Custom Form Record Opened",
        creating: "Custom Form Record Opened for Creating",
        /**
         * Payload: { "auto convert": true/false }
         */
        created: "Custom Form Record Created",
    } as const,
} as const;
